import content from './content'
import fileAndDocuments from './file-and-documents'

export default {
  name: 'Cms',
  path: 'cms',
  meta: {
    label: 'cms',
    auth: 'cms'
  },
  component: {
    name: 'Cms',
    render(c) {
      return c('router-view')
    }
  },
  children: [content, fileAndDocuments]
}
